import "react-quill/dist/quill.snow.css";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import { useState, useTransition } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { approvalTimeSheet } from "../../data/ApiEndpoints";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { convertTo12HourFormat } from "../common-data/Converts";
import { Accordion } from "react-bootstrap";
import { showConfirmAlert } from "../components-react/ReactAlert";

const TSView = ({
  closeModal,
  rowData,
  userInfoData,
  sheetContentData,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const [remarks, setRemarks] = useState("");
  const [isPending, startTransition] = useTransition();
  const [actionType, setActionType] = useState(null);

  const [selectedShifts, setSelectedShifts] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // console.log("sheetContentData is==> ", sheetContentData);
  // console.log("rowData is==> ", rowData);

  const handleCheckboxChange = (shiftId) => {
    setSelectedShifts((prev) => {
      if (prev.includes(shiftId)) {
        return prev.filter((id) => id !== shiftId);
      } else {
        return [...prev, shiftId];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedShifts([]);
    } else {
      setSelectedShifts(sheetContentData.map((content) => content.uid));
    }
    setSelectAll(!selectAll);
  };

  // console.log("selectedShifts is==> ", selectedShifts);
  // console.log("rowData is==> ", selectedShifts);

  const handleApprovalProcess = async (status) => {
    const handleApprovalProcessUpdate = async (status) => {
      try {
        setActionType(status);
        startTransition(async () => {
          const payload = {
            aprv_rej_remarks: remarks,
            // approval_status: status,
            approval_slot_ids: selectedShifts,
            sheet_id: rowData.uid,
            aprv_rej_by: userInfoData.uid,
          };

          const result = await dispatch(
            commonPostPutApi({
              method: "POST",
              endpoint: approvalTimeSheet,
              payload: payload,
              token: userInfoData?.token,
            })
          );

          if (result?.payload?.status) {
            toast.success(result?.payload?.message || "Success!");
            closeModal();
            callFunction();
          } else {
            const errorMessage =
              result?.error?.message || result?.payload?.message;
            toast.error(errorMessage || "Something Went Wrong!");
          }
        });
      } catch (error) {
        toast.error(error.response?.data?.message || "Something went wrong!");
      } finally {
        setActionType(null);
      }
    };

    let confirmationMessage = "";
    // approved
    if (status === 1) {
      if (selectAll) {
        confirmationMessage = `You are approving all ${sheetContentData.length} shifts.`;
      } else if (selectedShifts.length > 0) {
        confirmationMessage = `You are approving ${
          selectedShifts.length
        } shift${selectedShifts.length > 1 ? "s" : ""}`;
      } else {
        confirmationMessage = `You are not selecting any shifts. Are you sure you want to proceed with approval?`;
      }
      // rejected
    } else if (status === 2) {
      if (selectedShifts.length > 0) {
        confirmationMessage = `You are rejecting ${selectedShifts.length} selected shifts. Are you sure?`;
      } else {
        confirmationMessage = `No shifts are selected. Are you sure you want to reject all?`;
      }
    }

    showConfirmAlert(handleApprovalProcessUpdate, confirmationMessage);
  };

  // console.log("sheetContentData===>", sheetContentData);

  return (
    <div className="createNewCTOModalContainer">
      <ModalHeadAndClose
        title={`View ${rowData?.user_name}'s Time Sheet`}
        onClose={closeModal}
      />
      <br />

      <div
        className=""
        style={{
          paddingBottom: "20px",
        }}
      >
        {sheetContentData?.length > 0 ? (
          <>
            {rowData?.shift_details && (
              <div
                className="only-mobile"
                style={{
                  backgroundColor: "#fff",
                  width: "100%",
                  padding: "10px",
                }}
              >
                {" "}
                {/* Show Accordion on small screens */}
                <div
                  className=""
                  style={{
                    backgroundColor: "#fff",
                    width: "100%",
                    padding: "10px",
                  }}
                >
                  <div>
                    <div>
                      <div
                        className="d-flex justify-content-between w-100 flexRowCenter"
                        style={{
                          paddingBottom: "8px",
                        }}
                      >
                        <span
                          className="sheet-time tb-head"
                          style={{
                            textAlign: "center",
                            width: "100%",
                          }}
                        >
                          SHIFT TIMINGS
                        </span>
                      </div>
                    </div>
                    <div>
                      <div
                        className="shift-details flexColCenter"
                        style={{
                          paddingBottom: "12px",
                          fontWeight: "600",
                          textTransform: "uppercase",
                        }}
                      >
                        {rowData?.shift_details?.map((shift, index) => (
                          <div key={index} className="flexRowCenter">
                            {convertTo12HourFormat(shift?.start_time)} -{" "}
                            {convertTo12HourFormat(shift?.end_time)}(
                            {shift?.shift_name})
                          </div>
                        ))}
                      </div>
                      {userInfoData?.account_type === "cluster_manager" &&
                        rowData?.approval_status === 0 && (
                          <div
                            className=""
                            style={{
                              display: "flex",
                              // justifyContent: "space-between",
                              fontWeight: "600",
                              gap: "14px",
                              alignItems: "center",
                              paddingLeft: "8px",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={selectAll}
                              onChange={handleSelectAll}
                              style={{
                                width: "18px",
                                height: "18px",
                                fontWeight: "600",
                              }}
                            />
                            <label className="">Approve All</label>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {rowData?.shift_details && (
              <div className="hideMobile">
                {" "}
                {/* Show table view on large screens */}
                <div className="time-sheet-box">
                  <div className="sheet-item sheet-left">
                    <span
                      className="sheet-time tb-head"
                      style={{
                        padding: "20px",
                      }}
                    >
                      SHIFT TIMINGS
                    </span>
                  </div>
                  <div className="sheet-item sheet-right tb-head sheet_head_wrapper flex-row align-items-center justify-content-between px-3">
                    <div className="flex-k">
                      {rowData?.shift_details?.map((shift, index) => (
                        <div
                          key={shift.shift_id}
                          className="shift-item flexRowCenter gap-1 shift-time-tb-head"
                          style={{
                            fontWeight: "600",
                            fontSize: "20px",
                          }}
                        >
                          <span>
                            {convertTo12HourFormat(shift?.start_time)} -{" "}
                            {convertTo12HourFormat(shift?.end_time)}{" "}
                            <span
                              className="font-semibold"
                              style={{
                                textTransform: "uppercase",
                              }}
                            >
                              ({shift?.shift_name})
                            </span>
                            {index < rowData?.shift_details.length - 1 && " - "}
                          </span>
                        </div>
                      ))}
                    </div>
                    {userInfoData?.account_type === "cluster_manager" &&
                      rowData?.approval_status === 0 && (
                        <div className="Select_All_Wrapper flexRowCenter gap-1">
                          <label className="approve-all-label">
                            Approve All
                          </label>
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                            style={{ width: "20px", height: "20px" }}
                          />
                        </div>
                      )}
                  </div>
                </div>
              </div>
            )}

            <div className="hideMobile">
              {sheetContentData &&
                sheetContentData.map((content, index) => (
                  <div className="time-sheet-box" key={index}>
                    <div className="sheet-item sheet-left">
                      <span className="sheet-time">
                        {`${convertTo12HourFormat(
                          content.slot_start_time
                        )} - ${convertTo12HourFormat(content.slot_end_time)}`}
                      </span>
                    </div>
                    <div className="sheet-item sheet-right flex-row align-items-center justify-content-between px-3">
                      <div
                        className="description-wrapper__time-sheet"
                        dangerouslySetInnerHTML={{
                          __html: content.description,
                        }}
                      />

                      <div className="flexRowCenter gap-2">
                        <div className="approval-status-wrapper">
                          {content?.is_approved === 0 ? (
                            <button className="btn btn-warning btn-sm">
                              Pending
                            </button>
                          ) : content?.is_approved === 1 ? (
                            <button className="btn btn-success btn-sm">
                              Approved
                            </button>
                          ) : (
                            <button className="btn btn-danger btn-sm">
                              Rejected
                            </button>
                          )}
                        </div>

                        {userInfoData?.account_type === "cluster_manager" &&
                          content?.is_approved === 0 && (
                            <div className="checkbox-wrapper">
                              <input
                                type="checkbox"
                                style={{ width: "18px", height: "18px" }}
                                checked={selectedShifts.includes(content.uid)}
                                onChange={() =>
                                  handleCheckboxChange(content.uid)
                                }
                              />
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                ))}
            </div>

            {sheetContentData && (
              <>
                <div
                  className="only-mobile"
                  style={{
                    width: "100%",
                  }}
                >
                  <Accordion defaultActiveKey="0">
                    {sheetContentData.map((content, index) => (
                      <Accordion.Item eventKey={index} key={index}>
                        <Accordion.Header>
                          <div className="d-flex justify-content-between w-100 align-items-center">
                            <div
                              className=""
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              {userInfoData?.account_type ===
                                "cluster_manager" &&
                                content?.is_approved === 0 && (
                                  <div className="checkbox-wrapper ms-2">
                                    <input
                                      type="checkbox"
                                      style={{ width: "18px", height: "18px" }}
                                      checked={selectedShifts.includes(
                                        content.uid
                                      )}
                                      onChange={() =>
                                        handleCheckboxChange(content.uid)
                                      }
                                    />
                                  </div>
                                )}

                              <span
                                className="sheet-time"
                                style={{
                                  fontSize: "13px",
                                }}
                              >
                                {`${convertTo12HourFormat(
                                  content.slot_start_time
                                )} - ${convertTo12HourFormat(
                                  content.slot_end_time
                                )}`}
                              </span>
                            </div>

                            {content?.is_approved === 0 ? (
                              <button className="btn btn-warning btn-sm">
                                Pending
                              </button>
                            ) : content?.is_approved === 1 ? (
                              <button className="btn btn-success btn-sm">
                                Approved
                              </button>
                            ) : (
                              <button className="btn btn-danger btn-sm">
                                Rejected
                              </button>
                            )}
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div
                            className="description-wrapper__time-sheet"
                            dangerouslySetInnerHTML={{
                              __html: content.description,
                            }}
                          />
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                </div>
              </>
            )}

            {userInfoData?.account_type === "cluster_manager" &&
              rowData?.approval_status === 0 && (
                <div className="approval-section mt-4">
                  <div className="form-group mb-3">
                    <label>Remarks (Optional)</label>
                    <textarea
                      className="form-control cluster-manager-remarks"
                      value={remarks}
                      onChange={(e) => setRemarks(e.target.value)}
                      placeholder="Enter remarks..."
                      rows={3}
                    />
                  </div>
                  <div className="d-flex gap-2 justify-content-end">
                    {selectedShifts.length > 0 ? (
                      <>
                        <button
                          className="btn btn-success"
                          onClick={() => handleApprovalProcess(1)}
                          disabled={isPending && actionType === 1}
                        >
                          {isPending && actionType === 1
                            ? "Processing..."
                            : "Approve"}
                        </button>
                      </>
                    ) : (
                      <button
                        className="btn btn-danger"
                        onClick={() => handleApprovalProcess(2)}
                        disabled={isPending && actionType === 2}
                      >
                        {isPending && actionType === 2
                          ? "Processing..."
                          : "Reject"}
                      </button>
                    )}
                  </div>
                </div>
              )}
          </>
        ) : (
          <span className=""></span>
        )}
      </div>
    </div>
  );
};

export default TSView;

// <span className="info">No Time Sheet Data Found!</span>
